import {
  Component,
  Host,
  h,
  Prop,
  State,
  Listen,
  Event,
  EventEmitter,
} from '@stencil/core';
import {
  SessionDisplay,
  SessionRepository,
  SessionModel,
  SessionStayPeriod,
} from '@cesare';
import { getSessionFromSessionStorageOrEnv } from '../../core/app/app';

@Component({
  tag: 'qw-calendar',
  styleUrl: 'qw-calendar.scss',
  shadow: false,
})
export class QwCalendar {
  @Prop() qwCalendarId: string;
  @Prop() qwCalendarNumberOfMonths: number = 1;
  @Prop() qwCalendarResponsive: boolean = true;
  @Prop() qwCalendarSyncOnChange: boolean = true;
  @Prop() qwCalendarDesktopLimit: number = 700;
  @Prop() qwCalendarConfig: any; // flatpickr Options
  @State() session: SessionModel;
  @State() stayPeriod: SessionStayPeriod;
  @State() isSessionLoading: boolean;
  @State() locale: SessionDisplay['culture'];
  @Event() qwCalendarChange: EventEmitter<SessionStayPeriod>;
  @Event() qwBasketWillBeReset: EventEmitter<void>;

  public componentWillLoad() {
    this.session = getSessionFromSessionStorageOrEnv();
    this.stayPeriod = {} as SessionStayPeriod;
    setTimeout(
      () => (this.stayPeriod = { ...this.session.context.stayPeriod }),
    );
    this.locale = this.session.display.culture;
    SessionRepository.sessionIsLoading$.subscribe(
      (isLoading) => (this.isSessionLoading = isLoading),
    );
  }

  @Listen('qwCalendarPickerChangeDates', { target: 'window' })
  updateStayPeriod(event: CustomEvent<SessionStayPeriod>) {
    this.stayPeriod = { ...event.detail };
    this.qwCalendarChange.emit(this.stayPeriod);
    document.querySelectorAll('qw-calendar').forEach((cal) => {
      cal.classList.remove('qw-component--show');
    });

    if (!this.qwCalendarSyncOnChange) {
      return;
    }

    if (SessionRepository.sessionHasRoomsSync()) {
      this.qwBasketWillBeReset.emit();
    }
  }

  render() {
    return (
      <Host>
        <qw-calendar-picker
          qwCalendarPickerId={this.qwCalendarId}
          qwCalendarPickerDesktopLimit={this.qwCalendarDesktopLimit}
          qwCalendarPickerResponsive={this.qwCalendarResponsive}
          qwCalendarPickerNumberOfMonths={this.qwCalendarNumberOfMonths}
          qwCalendarPickerDisabled={this.isSessionLoading}
          qwCalendarPickerLocale={this.locale}
          qwCalendarPickerStayPeriod={this.stayPeriod}
          qwCalendarPickerConfig={
            this.qwCalendarConfig ? JSON.parse(this.qwCalendarConfig) : {}
          }
        />
      </Host>
    );
  }
}
